<template>
  <div class="mit-admin-page mit-page">

    <v-container fluid class="pt-0 mt-0">
        <BaseMitLoading :show="loadingReservationsList || loadingReservationsCalendar || loadingSave || loadingDelete || loadSpaces" :fullscreen="false"/>
        <v-snackbar top :color="status.color" min-width="0" v-model="status.display" :timeout="status.timeout">
            <b>{{ status.message }}</b>
        </v-snackbar>
        <BaseMitReserveEdit :show="dialog" :allSpaces="spaces" :selectedSpace="selectedSpace" :existingReservationUniqueId="currentReservationUniqueId" @cancel="cancelReservation" @save="saveReservation" @delete="deleteReservation" @changed-reservation="editorChangedReservationId"/>
        <v-tabs color="" right height="30px">
          <v-tabs-slider></v-tabs-slider>
          <v-tab><v-icon class="pr-2">mdi-format-list-bulleted</v-icon> List</v-tab>
          <v-tab><v-icon class="pr-2">mdi-calendar-month</v-icon> Calendar</v-tab>

          <v-tab-item>
              <BaseMitDataTable
                title="Reservations"
                :editable="false"
                :headers="headers"
                :items="reservationsList"
                :showExpanded="true" 
                itemKey="id"
                :singleExpanded="true"
                >
                    <template v-slot:expanded-item="{ item }">
                        <!-- expand across all the columns, so use the header length -->
                        <td class="pa-1" :colspan="headers.length+1">
                        <v-simple-table class="row-pointer" fixed-header height="300px">
                            <template v-slot:default >
                            <!-- <span v-if="reservations && reservations.length > 0"> -->
                                <thead>
                                    <tr>
                                        <th class="text-left">Name</th>
                                        <th class="text-left">Space</th>
                                        <th class="text-left">Start</th>
                                        <th class="text-left">End</th>
                                        <th class="text-left">Setup State</th>
                                        <th class="text-left"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- @click="editReservation(r)" -->
                                    <tr v-for="r in item.recurring.children" :key="r.id">
                                    <td><h4>{{r.name || '(none)'}}</h4></td>
                                    <td>{{ r.spaceDetails.name }}</td>
                                    <!-- <td>{{ r.startDateTime.format('MM-DD-YYYY hh:mm A') }}</td> -->
                                    <td><span class="pr-2">{{ r.startDateTime.format('MM/DD/YY') }}</span><b>{{ r.startDateTime.format('h:mm A') }}</b></td>
                                    <!-- <td>{{ r.endDateTime.format('MM-DD-YYYY hh:mm A') }}</td> -->
                                    <td><span class="pr-2">{{ r.endDateTime.format('MM/DD/YY') }}</span><b>{{ r.endDateTime.format('h:mm A') }}</b></td>
                                    <td>
                                        <div v-if="item.setupState && item.setupState.length > 0">{{item.setupState}}</div>
                                        <div v-else>-</div>
                                    </td>
                                    <td><v-btn class="" small text outlined color="primary" elevation="0" @click="editReservation(r)">Modify</v-btn></td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        </td>
                    </template>
                    <template v-slot:item.icon="{ item }">
                                <v-icon v-if="item.recurring" color="primary darken-1" class="pr-3">mdi-calendar-refresh-outline</v-icon>
                                <v-icon v-else color="primary darken-1" class="pr-3">mdi-calendar-today-outline</v-icon>
                    </template>
                    <template #item.data-table-expand="{ index, item, isExpanded, expand }">
                    <!-- @click="expand(!isExpanded)"  -->
                    <td v-if="item.recurring" class="text-start">
                        <!--  @click="tableExpand(expand, isExpanded, item)"-->
                        <v-btn icon 
                            @click="tableExpand(expand, isExpanded, item)"
                            class="v-data-table__expand-icon"
                            :class="{'v-data-table__expand-icon--active' : isExpanded}">
                        <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                    </td>
                </template>
                <template v-slot:item.modify="{ item }">
                    <v-btn class="" small text outlined color="primary" elevation="0" @click="editReservation(item)">Modify</v-btn>
                </template>
                <!-- <template v-slot:item.startDate="{ item }">
                    {{ item.startDateTime.format('ddd MMM DD YYYY') }}
                </template> -->
                <template v-slot:item.name="{ item }">
                    <b>{{item.name}}</b>
                </template>
                <template v-slot:item.space="{ item }">
                    <a style="text-decoration: none;" target="_blank" rel="noopener noreferrer" :href="spacesUrl+'/maps/'+item.spaceDetails.buildingMitId+'?s='+item.mitId+'&l='+item.spaceDetails.level">
                        <v-icon class="pr-2" color="primary">mdi-map-marker</v-icon>{{ item.spaceDetails.name }}
                    </a>
                </template>
                <template v-slot:item.startTime="{ item }">
                    <!-- {{ item.startDateTime.format('MM/DD/YY hh:mm A') }} -->
                    <span class="pr-2">{{ item.startDateTime.format('MM/DD/YY') }}</span><b>{{ item.startDateTime.format('h:mm A') }}</b>
                </template>
                <!-- <template v-slot:item.duration="{ item }">
                    {{ reservationDuration(item.startDateTime, item.endDateTime) }}
                </template> -->
                <template v-slot:item.endTime="{ item }">
                    <!-- {{ item.endDateTime.format('MM/DD/YY hh:mm A') }} -->
                    <span class="pr-2">{{ item.endDateTime.format('MM/DD/YY') }}</span><b>{{ item.endDateTime.format('h:mm A') }}</b>
                </template>
                <!-- <template v-slot:item.secondaryOwners="{ item }">
                    <div v-if="item.secondaryOwners.length < 1">-</div>
                    <div v-else>item.secondaryOwners.length</div>
                </template> -->
                <template v-slot:item.setupState="{ item }">
                    <div v-if="item.setupState && item.setupState.length > 0">{{item.setupState}}</div>
                    <div v-else>-</div>
                </template>
                </BaseMitDataTable>
          </v-tab-item>
          <v-tab-item>
            <BaseMitMyReservationCalendar :reservations="reservationsCalendar" :user="userModel" :focusTime="'08:00 am'" @clicked-event="editReservation" @dateChanged="calendarDateChanged" :calendarColors="calendarColors"/>
          </v-tab-item>
        </v-tabs>
    </v-container>
  </div>
</template>

<script>
  import moment from 'moment';
  import BaseMitDataTable from '../BaseMitDataTable.vue';
  import BaseMitLoading from '../BaseMitLoading.vue';
  import BaseMitUserService from '../../services/BaseMitUserService.js';

  import BaseMitMyReservationCalendar from './BaseMitMyReservationCalendar.vue'

  import BaseMitReserveEdit from './BaseMitReserveEdit.vue';
  
  import MitReserveService from '../../services/BaseMitReserveService.js';
  import MitSpacesApiService from '../../services/BaseMitReserveSpacesService.js';
  import BaseMitConfigService from '../../services/BaseMitConfigService.js';

  export default {
    name: 'MitMyReservations',
    components: {
        BaseMitLoading,
        BaseMitDataTable,
        BaseMitReserveEdit,
        BaseMitMyReservationCalendar
    },
    props: {
        userModel: Object
    },
    data: function() {
      return {
          status:{
            display:false,
            timeout:3000,
            message:'Saved!',
            color:'primary'
          },
          dialog:false,
          loadingDelete:false,
          loadingSave:false,
          loadingEdit:false,
          loadingReservationsList:true,
          loadingReservationsCalendar:false,
          reservationsList:[],
          reservationsCalendar:[],
          reservationsCalendarCurrentDateRange:null,
          currentReservationUniqueId:null,
          existingReservationsForSpace:[],
          errorsSpaces:[],
          selectedSpace:null,
          selectedUsers:[],
          allowedUsersControl:null,
          spaces:[],
          spacesUrl:null,
          calendarColors:MitReserveService.getCalendarColors(),
          tableCurrentExpandFunction:null,//used to close the table row if its expanded, when updating
          headers:[
            { text: '', value: 'data-table-expand', width:10 },
            {text: '',sortable: true,value: 'icon', width:10},
            {text: 'Name',sortable: true,value: 'name'},
            
            {text: 'Space',sortable: true,value: 'space'},
            {text: 'Start',sortable: true,value: 'startTime'},
            {text: 'End',sortable: true,value: 'endTime'},
            {text: 'Owner',sortable: true,value: 'owner'},
            //{text: 'Additional Owners',sortable: false,value: 'secondaryOwners'},
            {text: 'Setup',sortable: false,value: 'setupState'},
            {text: '',sortable: false,value: 'modify'},
         ],
      }
    },
    created() {
        this.getReservationsForList();
        this.requestGetSpaces();
       // this.getReservationsForCalendar();
        //request for calendar reservations view gets requested by the calendar sending a date change
        //event on render and then on user date changes
    },
    mounted() {
        this.spacesUrl = BaseMitConfigService.get('CLIENT_API_SPACES');
        if(this.$route.params.id){
                this.currentReservationUniqueId = this.$route.params.id;
                this.dialog = true;
        }
    },
    methods: {
        // reservationDuration(start, end){
        //     return moment.duration(end.diff(start)).humanize(false)
        // },
        requestGetSpaces(){
          this.loadSpaces = true;

          return MitSpacesApiService.getReservableSpaces()
            .then((data) => {
                this.spaces = data.spaces;
                this.spaceInfo = MitSpacesApiService.getSpaceStats(this.spaces);
                this.loadSpaces = false;
            })
            .catch((error) => {
                this.loadSpaces = false;
                this.status.message = 'An error occurred trying to get spaces';
                this.status.display = true;
                this.status.color = 'red';

                console.log('ERROR:', error);
            });
      },
        tableExpand(expandFunction, isExpanded){
            this.tableCurrentExpandFunction = expandFunction;
            expandFunction(!isExpanded);
        },
          editorChangedReservationId(uniqueId){
              this.updateUrl(uniqueId)
          },
          calendarDateChanged(daterange){
            this.reservationsCalendarCurrentDateRange = daterange;
            this.getReservationsForCalendar();
          },
          updateUrl(uniqueId){
            let url;

            if(uniqueId !== null && uniqueId.length > 0){
                url = {
                    path: '/reservations/my/'+ uniqueId,
                    query: {}
                }
            }
            else{
                url = {
                    path: '/reservations/my',
                    query: {}
                }
            }
            
            //test to make sure we don't try to change to the same url.
            //the router doesn't like this
            if(this.$router.currentRoute.path != url.path){
              this.$router.push(url);
            }
        },
        deleteReservation(reservation){
            this.loadingDelete = true;
            this.dialog = false;
            this.updateUrl(null);
            MitReserveService.delete(reservation.uniqueId)
              .then((data) => {
                  this.loadingDelete = false;

                  if(data.numDeleted <= 0){
                      this.status.message = 'Could not delete reservation or reservation was already deleted.';
                      this.status.color = 'red';
                      this.status.display = true;
                  }
                  else{
                      this.status.message = 'Deleted Reservation.',
                      this.status.color = 'primary'
                      this.status.display = true;
                  }
                  this.getReservationsForList();
                  this.getReservationsForCalendar();
              })
              .catch((error) => {
                  this.loadingDelete = false;
                  this.status.message = 'An error occurred trying to get delete the reservation.';
                  this.status.display = true;
                  this.status.color = 'red';
                  this.errorsSpaces = ['Error getting available spaces from space app.']
                  console.log('ERROR:', error);
              });

        },
        editReservation(reservation){
            this.updateUrl(reservation.uniqueId);
            this.dialog = true;
            this.currentReservationUniqueId = reservation.uniqueId;
        },
        getReservationsForList(){
                this.loadingReservationsList = true;

                BaseMitUserService.getCurrentUser()
                  .then((user) => {
                    return MitReserveService.getMyReservationsRecurringGrouped(user.csailId)
                  })
                  .then((data) => {
                      this.loadingReservationsList = false;
                      this.reservationsList = data.all
                  })
                  .catch((error) => {
                      this.loadingReservationsList = false;
                      this.status.message = 'An error occurred trying to get the reservable spaces.';
                      this.status.display = true;
                      this.status.color = 'red';
                      this.errorsSpaces = ['Error getting available spaces from space app.']
                      console.log('ERROR:', error);
                  });
        },
        getReservationsForCalendar(){
          this.loadingReservationsCalendar = true;
          return new Promise ((resolve, reject) => {
          
              BaseMitUserService.getCurrentUser()
                .then((user) => {
                    return MitReserveService.getMyReservations(user.csailId, this.reservationsCalendarCurrentDateRange)
                })
                .then((data) => {
                    this.reservationsCalendar = data.all;
                    this.loadingReservationsCalendar = false;
                })
                .catch((error) => {
                    this.loadingReservationsCalendar = false;
                    this.status.message = 'An error occurred trying to get reservations';
                    this.status.display = true;
                    this.status.color = 'red';

                    console.log('ERROR:', error);
                });
          });
      },
        changedAllowedUser(items){
            this.selectedUsers = items.map(a => a.id);
        },
        newReservationModel(){
            return {};
        },
        editReservationModel(item){
            return item;
        },
        cancelReservation(){
          this.updateUrl(null);
          this.dialog = false;
        },
        saveReservation(reservation){
            this.loadingSave = true;

            MitReserveService.save(reservation)
              .then((data) => {
                  this.loadingSave = false;
                  this.status.message = 'Saved!',
                  this.status.color = 'primary'
                  this.status.display = true;
                  this.dialog = false;
                  this.updateUrl(null);
                  this.getReservationsForList();
                  this.getReservationsForCalendar();
              })
              .catch((error) => {
                  this.loadingSave = false;
                  this.dialog = false;
                  this.updateUrl(null);
                  this.status.message = 'An error occurred trying to get the reservable spaces.';
                  this.status.display = true;
                  this.status.color = 'red';
                  this.errorsSpaces = ['Error getting available spaces from space app.']
                  console.log('ERROR:', error);
              });
        }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-app-loading-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height:100vh;
  }
</style>
